export const DATA_NOT_FETCHED = 'DATA_NOT_FETCHED';
export const DATA_FETCHING = 'DATA_FETCHING';
export const DATA_SUCCEEDED = 'DATA_SUCCEEDED';
export const DATA_FAILED = 'DATA_FAILED';
